import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { OrderModel } from '@core/services/api.service';
import { Store } from '@ngxs/store';
export interface Section {
  name: string;
  updated: Date;
}

@Component({
  selector: 'app-orders-details',
  templateUrl: './orders-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrdersDetailsComponent {
  @Input() order: OrderModel
  @Input() isLoading: boolean;
 
  constructor(private store: Store) { }

}
